<h1 mat-dialog-title>
  <div class="d-flex align-items-center justify-content-between">
    <div>
      <i class="far fa-cog i-16 mr-4"></i>
      <span>Job State</span>
    </div>
    <div *ngIf="data.showClose || completed">
      <button trgButton class="dialog-close-btn">
        <i class="fal fa-times i-12 p-relative ot-1"></i>
      </button>
    </div>
  </div>
</h1>
<div mat-dialog-content>
  <app-job-progress [job]="data.job" [jobTitle]="data.jobTitle" (completed)="setCompleted($event)">
  </app-job-progress>
</div>
<div mat-dialog-actions align="center">
  <button trgButton color="primary" class="min-w-100 mr-10" (click)="dismissAllClick()">
    <span>Dismiss All</span>
  </button>
  <button *ngIf="data.showClose || completed"
          trgButton
          color="primary"
          class="min-w-100"
          (click)="dialogRef.close()">Close</button>
</div>
